import { Footer } from "../footer";
import { WhiskymofoOneColumnFooter } from "./WhiskymofoOneColumnFooter";
import { isWhiskymofoSignupPage } from "../../utils/is-page";
import { useLocation } from "@reach/router";

type PageFooterProps = {
  withSearchBox?: boolean;
};

export const PageFooter = ({ withSearchBox }: PageFooterProps): JSX.Element => {
  const location = useLocation();

  if (isWhiskymofoSignupPage(location?.pathname)) {
    return <WhiskymofoOneColumnFooter />;
  }

  return <Footer withSearchBox={withSearchBox} />;
};
